import * as React from 'react';
import { Label } from '@here/hds-label';
// eslint-disable-next-line no-new
new Label();
const HDSLabel = React.forwardRef((props, ref) => {
    const { children, primaryLabel, secondaryLabel, className, ...rest } = props;
    return (React.createElement("hds-label", { ref: ref, ...(className && { class: className }), ...rest },
        primaryLabel ? React.createElement("span", null, primaryLabel) : children,
        secondaryLabel && React.createElement("span", { slot: "secondary" }, secondaryLabel)));
});
HDSLabel.defaultProps = {
    variant: 'default',
    type: 'default',
};
export default HDSLabel;
//# sourceMappingURL=HDSLabel.js.map